import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuickbooksRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 40 40",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#2ca01c",
		d: "M19.8 39.8a20 20 0 1 0 0-40 20 20 0 0 0 0 40"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M13.1 12a8 8 0 0 0-7.8 7.8 8 8 0 0 0 7.8 7.7h1.1v-2.8h-1.1a5 5 0 0 1-4.9-5 5 5 0 0 1 4.9-4.8h2.7v15a3 3 0 0 0 2.9 3v-21zm13.3 15.5c4.3 0 7.8-3.4 7.8-7.7a8 8 0 0 0-7.8-7.8h-1v2.9h1a5 5 0 0 1 5 4.9 5 5 0 0 1-5 4.9h-2.6V9.5a3 3 0 0 0-3-2.8v20.8z"
	})]
});
export default SvgQuickbooksRegularIcon;
